import { useState, useEffect } from 'react';

interface ReviewSettings {
  reviewsAutoPullSetting: boolean;
  reviewsAutoReplySetting: boolean;
  reviewAutoReplyEligibleRating: number[];
  reviewsAutoReplyEnglishTranslation: boolean;
  useReplyTemplate: boolean;
  replyTemplate: string;
}

interface UseReviewSettingsReturn {
  settings: ReviewSettings;
  updateSetting: <K extends keyof ReviewSettings>(key: K, value: ReviewSettings[K]) => void;
  resetSettings: (store: any) => void;
}

const useReviewSettings = (store: any): UseReviewSettingsReturn => {
  const [settings, setSettings] = useState<ReviewSettings>({
    reviewsAutoPullSetting: store?.reviewsAutomationSettings?.reviewsAutoPullSetting ?? false,
    reviewsAutoReplySetting: store?.reviewsAutomationSettings?.reviewsAutoReplySetting ?? false,
    reviewAutoReplyEligibleRating: store?.reviewsAutomationSettings
      ?.reviewAutoReplyEligibleRating ?? [4, 5],
    reviewsAutoReplyEnglishTranslation:
      store?.reviewsAutomationSettings?.reviewsAutoReplyEnglishTranslation ?? false,
    useReplyTemplate: store?.reviewsAutomationSettings?.useReplyTemplate ?? false,
    replyTemplate: store?.reviewsAutomationSettings?.replyTemplate ?? '',
  });

  const updateSetting = <K extends keyof ReviewSettings>(key: K, value: ReviewSettings[K]) => {
    setSettings((prev) => ({ ...prev, [key]: value }));
  };

  const resetSettings = (newStore: any) => {
    setSettings({
      reviewsAutoPullSetting: newStore?.reviewsAutomationSettings?.reviewsAutoPullSetting ?? false,
      reviewsAutoReplySetting:
        newStore?.reviewsAutomationSettings?.reviewsAutoReplySetting ?? false,
      reviewAutoReplyEligibleRating: newStore?.reviewsAutomationSettings
        ?.reviewAutoReplyEligibleRating ?? [4, 5],
      reviewsAutoReplyEnglishTranslation:
        newStore?.reviewsAutomationSettings?.reviewsAutoReplyEnglishTranslation ?? false,
      useReplyTemplate: newStore?.reviewsAutomationSettings?.useReplyTemplate ?? false,
      replyTemplate: newStore?.reviewsAutomationSettings?.replyTemplate ?? '',
    });
  };

  useEffect(() => {
    resetSettings(store);
  }, [store]);

  return { settings, updateSetting, resetSettings };
};

export default useReviewSettings;
